import { useService } from 'react-reservice';

import { tradeFormService } from './service';
import { IPreservedValuesObj } from './types';

export const useTradeOrderType = () => useService(tradeFormService, (context) => context.orderType);
export const useTradeOrderTypeLabel = () => useService(tradeFormService, (context) => context.orderTypeLabel);
export const useBuySellType = () => useService(tradeFormService, (context) => context.buySellType);
export const useTradeLoading = () => useService(tradeFormService, (context) => context.loading);

export const useSelectedSymbolBuySellType = (isSelectedSymbol: boolean) => {
  return useService(tradeFormService, (context) => (isSelectedSymbol ? context.buySellType : undefined));
};

export const useTradeFormPreservedValues = () =>
  useService(tradeFormService, (context) => context.preservedValues || {});

export const setTradeFormPreservedValues = (values: IPreservedValuesObj) => {
  tradeFormService.setPreservedValues(values);
};

export const useFromQuoteboardSymbol = () => useService(tradeFormService, (context) => context.fromQuoteboardSymbol);
